// 待审批
export const SIGNSURE = [
  {
    title: "发起人",
    dataIndex: "StaffName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属大区",
    dataIndex: "RegionName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属公司",
    dataIndex: "CompanyName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "审批事项",
    dataIndex: "ApprovalMattersName",
    width: 180,
    ellipsis:true,
  },
  {
    title: "审批节点",
    dataIndex: "ApproveNodeName",
    width: 220,
    ellipsis:true,
  },
  {
      title: "发起时间",
      dataIndex: "ApplicationTime",
      width: 190,
      ellipsis:true,
  },
  {
      title: "操作",
      fixed: "right",
      width: 104,
      slots: { customRender: "btn" },
  },
];
// 抄送我的
export const SIGNCOPY = [
  {
    title: "发起人",
    dataIndex: "StaffName",
    width: 120,
     ellipsis:true,
  },
  {
    title: "归属大区",
    dataIndex: "RegionName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属公司",
    dataIndex: "CompanyName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "审批事项",
    dataIndex: "ApprovalMattersName",
    width: 180,
    ellipsis:true,
  },
  {
    title: "审批节点",
    dataIndex: "ApproveNodeName",
    width: 220,
    ellipsis:true,
  },
  {
      title: "发起时间",
      dataIndex: "ApplicationTime",
      width: 190,
      ellipsis:true,
  },
  {
      title: "操作",
      fixed: "right",
      width: 80,
      slots: { customRender: "btn" },
  },
];
// 流程列表
export const PROCESS = [
    {
      title: "发起人",
      dataIndex: "StaffName",
      width: 120,
      ellipsis:true,
    },
    {
      title: "归属大区",
      dataIndex: "RegionName",
      width: 120,
      ellipsis:true,
    },
    {
      title: "归属公司",
      dataIndex: "CompanyName",
      width: 120,
      ellipsis:true,
    },
    {
      title: "审批事项",
      dataIndex: "ApprovalMattersName",
      width: 180,
      ellipsis:true,
    },
    {
      title: "审批节点",
      dataIndex: "ApproveNodeName",
      width: 220,
      ellipsis:true,
    },
    {
      title: "审批状态",
      dataIndex: "ApproveStatusName",
      width: 160,
      ellipsis:true,
      slots: { customRender: "constatus" },
    },
    // {
    //     title: "待审批人",
    //     dataIndex: "ApproveStaffName",
    //     width: 120,
    //     ellipsis:true,
    //     slots: { customRender: "ApproveStaffName" },
    // },
    {
      title: "申请时间",
      dataIndex: "ApplyTime",
      width: 140,
      ellipsis:true,
    },
    {
      title: "操作",
      width: 80,
      fixed: "right",
      slots: { customRender: "btn" },
  },
]; 
// 已审批、我发起的
export const SIGNCONTING = [
  {
    title: "发起人",
    dataIndex: "StaffName",
    width: 120,
     ellipsis:true,
  },
  {
    title: "归属大区",
    dataIndex: "RegionName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属公司",
    dataIndex: "CompanyName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "审批事项",
    dataIndex: "ApprovalMattersName",
    width: 180,
    ellipsis:true,
  },
  {
    title: "审批节点",
    dataIndex: "ApproveNodeName",
    width: 220,
    ellipsis:true,
  },
  {
    title: "审批状态",
    dataIndex: "Status",
    width: 120,
    ellipsis:true,
    slots: { customRender: "constatus" },
  },
  {
      title: "发起时间",
      dataIndex: "ApplicationTime",
      width: 190,
      ellipsis:true,
  },
  {
      title: "操作",
      fixed: "right",
      width: 80,
      ellipsis:true,
      slots: { customRender: "btn" },
  },
];
// 申请列表
export const APPLY = [
  {
    title: "发起人",
    dataIndex: "StaffName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属大区",
    dataIndex: "RegionName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属公司",
    dataIndex: "CompanyName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "公司类型",
    dataIndex: "TypeName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "选定城市",
    dataIndex: "LocationName",
    width: 120,
    ellipsis:true,
  },
  {
      title: "预计开业时间",
      dataIndex: "ExpectOpenTime",
      width: 140,
      ellipsis:true,
  },
  {
    title: "审批状态",
    dataIndex: "StatusText",
    width: 160,
    ellipsis:true,
    slots: { customRender: "constatus" },
  },
  // {
  //   title: "待审批人",
  //   dataIndex: "ApproveStaffName",
  //   width: 120,
  //   ellipsis:true,
  //   slots: { customRender: "ApproveStaffName" },
  // },
  {
    title: "申请时间",
    dataIndex: "ApplyTime",
    width: 140,
    ellipsis:true,
  },
  {
      title: "操作",
      fixed: "right",
      width: 80,
      slots: { customRender: "btn" },
  },
];

// 工商变更列表
export const CHANGES = [
  {
    title: "发起人",
    dataIndex: "StaffName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属大区",
    dataIndex: "RegionName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "归属公司",
    dataIndex: "CompanyName",
    width: 120,
    ellipsis:true,
  },
  {
    title: "变更内容",
    dataIndex: "ChangeConent",
    width: 320,
  },
  {
    title: "当前审批节点",
    dataIndex: "CurrentApproveNodeName",
    width: 280,
  },
  {
    title: "申请时间",
    dataIndex: "ApplyTime",
    width: 140,
    ellipsis:true,
  },
  {
      title: "操作",
      fixed: "right",
      width: 80,
      slots: { customRender: "btn" },
  },
];